import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'legal-disclaimer',
  styleUrl: 'legal-disclaimer.scss',
  shadow: true,
})
export class LegalDisclaimer {
  private baseClass = 'legal-disclaimer';

  /**
   * The headline text displayed as the header.
   */
  @Prop() headline?: string = '';

  /**
   * The label for the acknowledgment button.
   */
  @Prop() buttonLabel: string = '';

  /**
   * The label for the checkbox.
   */
  @Prop() checkboxLabel: string = '';

  /**
   * Event emitted when the button is clicked.
   */
  @Event() disclaimerSubmitted: EventEmitter<void>;

  /**
   * State to track whether the disclaimer is visible.
   */
  @State() isVisible: boolean = true;

  /**
   * State to track whether the checkbox is checked.
   */
  @State() isCheckboxChecked: boolean = false;

  private handleCheckboxChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.isCheckboxChecked = target.checked;
  };

  private handleSubmit = () => {
    // Todo: Check whether or not the service case has been taken
    if (this.isCheckboxChecked) {
      this.disclaimerSubmitted.emit();
      this.isVisible = false;
    }
  };

  render() {
    const hostClass = this.isVisible ? this.baseClass : `${this.baseClass} ${this.baseClass}--hidden`;

    return (
      <Host class={hostClass} role="region" aria-labelledby={this.baseClass}>
        <ux-copy variant="title" id="disclaimer-header" class={`${this.baseClass}__header ux-text-title ux-text-title--light`}>
          {this.headline}
        </ux-copy>
        <div class={`${this.baseClass}__content`}>
          <slot></slot>
        </div>
        <ux-checkbox
          class={`${this.baseClass}__checkbox`}
          value="checked"
          label={this.checkboxLabel}
          name="input"
          required="true"
          onInput={this.handleCheckboxChange}
        ></ux-checkbox>
        <ux-button variant="primary" class={`${this.baseClass}__button`} disabled={!this.isCheckboxChecked} onClick={this.handleSubmit}>
          {this.buttonLabel}
        </ux-button>
      </Host>
    );
  }
}
